import apiClient, { ApiResponse } from './client';

// ═══════════════════════════════════════════════════════════════════
// TYPES (mirror apps/api oauth/connections.service.ts)
// ═══════════════════════════════════════════════════════════════════

export interface Connection {
  grantId: string;
  clientId: string | null;
  clientName: string | null;
  scopes: string[];
  createdAt: string;
  expiresAt: string | null;
}

export interface RevokeConnectionResult {
  grantId: string;
  revoked: true;
  cancelledJobs: number;
}

/**
 * Human-readable scope labels for the Connections page.
 *
 * NOTE: This is a deliberate parallel copy, not a shared source: the
 * consent page shows German labels (OAUTH_SCOPE_DETAILS in
 * apps/api/src/oauth/oauth.constants.ts), the web app shows English
 * ones. When a scope is added, removed or reworded, update BOTH maps
 * together.
 */
export const SCOPE_LABELS: Record<string, string> = {
  'designdeck:read': 'Read catalog and listings',
  'designdeck:write': 'Create and edit drafts',
  'designdeck:publish': 'Publish listings',
  offline_access: 'Stay connected',
  openid: 'Verify identity',
};

export function scopeLabel(scope: string): string {
  return SCOPE_LABELS[scope] ?? scope;
}

// ═══════════════════════════════════════════════════════════════════
// API FUNCTIONS
// ═══════════════════════════════════════════════════════════════════

export async function getConnections(): Promise<Connection[]> {
  const response =
    await apiClient.get<ApiResponse<Connection[]>>('/connections');
  return response.data.data;
}

export async function revokeConnection(
  grantId: string
): Promise<RevokeConnectionResult> {
  const response = await apiClient.delete<ApiResponse<RevokeConnectionResult>>(
    `/connections/${grantId}`
  );
  return response.data.data;
}
